import * as React from "react";
import { connect } from "react-redux";
import { Modal, Button, Grid } from "semantic-ui-react";

import { PartiallyMatchedEmployeeDetailModel, EmployeePartialMatch } from "../model";

import { PartiallyMatchedFormDetails } from "./PartiallyMatchedFormDetails";
import { PartiallyMatchedEmployeeRecordCard } from "./PartiallyMatchedEmployeeRecordCard";

interface OwnProps {
    open: boolean;
    title: string;
    onClose: () => void;
    formDetails: PartiallyMatchedEmployeeDetailModel;
    partialMatchedEmployee: EmployeePartialMatch;
    showAdditionalMatchDetails?: boolean;
    fieldClassNames: Record<string, string>;
    isSubmitting: boolean;
}

interface DispatchProps {
    matchToEmployeeRecord: (formCustomerId: string, referralId: string, employeeRecordCustomerId: string, employeeRecordId: string) => void;
}

export const MatchExistingEmployeeConfirmationModalUnconnected: React.FunctionComponent<OwnProps & DispatchProps> = props => {

    const onConfirm = () => {
        props.matchToEmployeeRecord(
            props.formDetails.customerId,
            props.formDetails.id,
            props.partialMatchedEmployee.customerId,
            props.partialMatchedEmployee.employeeRecordId);
        props.onClose();
    };

    return (
        <Modal open={props.open} size="small">
            <Modal.Header>
                Match selected records
            </Modal.Header>
            <Modal.Content>
                <p>Are you sure you want to match the following records? Please pay special attention to the differences in data.</p>
                <Grid centered divided>
                    <Grid.Row>
                        <Grid.Column width={6} className="partial-matches-column" textAlign="right">
                            <PartiallyMatchedFormDetails
                                formDetails={props.formDetails}
                                showAdditionalMatchDetails={props.showAdditionalMatchDetails}
                                title={props.title}
                            />
                        </Grid.Column>
                        <Grid.Column width={6} className="partial-matches-column" textAlign="left">
                            <PartiallyMatchedEmployeeRecordCard
                                employeeRecord={props.partialMatchedEmployee}
                                fieldClassNames={props.fieldClassNames}
                                referralCustomerId={props.formDetails.customerId}
                                referralId={props.formDetails.id}
                                key={props.partialMatchedEmployee.employeeRecordId}
                                showAdditionalMatchDetails={props.showAdditionalMatchDetails}
                                hideMoreRoute
                            />
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Modal.Content>
            <Modal.Actions>
                <Button onClick={props.onClose}>Cancel</Button>
                <Button primary onClick={onConfirm} loading={props.isSubmitting} disabled={props.isSubmitting}>Match</Button>
            </Modal.Actions>
        </Modal>
    );
};

export const MatchExistingEmployeeConfirmationModal = connect()(MatchExistingEmployeeConfirmationModalUnconnected);
